import styled from 'styled-components';
import { ripeLemon } from '@paradigm/design-system/src/colors';
import {
  LegsTableContainer as BaseContainer,
  Header,
  Row,
  TableHeader,
} from '#/components/rfq-common/LegsTable';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';

interface LegPrice {
  bid: string | null;
  ask: string | null;
}

interface Props {
  readonly prices: readonly LegPrice[];
  readonly className?: string;
}

export default function LegPricesTable({ prices, className }: Props) {
  return (
    <Container className={className}>
      <Header css="font-size: 0.8rem;">Leg Prices</Header>
      <TableHeader>
        <InputPriceRow>
          <span>Bid</span>
          <span>Ask</span>
        </InputPriceRow>
      </TableHeader>
      {prices.map((price) => (
        <InputPriceRow key={`${price.bid}-${price.ask}`}>
          <span>{price.bid ?? NEGATIVE_SIGN}</span>
          <span>{price.ask ?? NEGATIVE_SIGN}</span>
        </InputPriceRow>
      ))}
    </Container>
  );
}

export const Container = styled(BaseContainer)`
  margin-left: 5px;
  width: 200px;
  border: 1px solid ${ripeLemon};
`;

export const MarkPriceRow = styled(Row)`
  grid-template-columns: auto;
`;

export const InputPriceRow = styled(Row)`
  grid-template-columns: repeat(2, 1fr);
`;
